import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { useTourismData } from "../../context/TourismContext";
import { getImageUrl } from "../../services/api";

function CategoryThree() {
    // Get tourism data and actions from context
    const { airTicket, fetchAirTicketCategories } = useTourismData();
    const { categories } = airTicket;

    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchAirTicketCategories();
            } catch (error) {
                console.error('Error fetching AirTicket categories:', error);
            }
        };
        
        fetchData();
    }, [fetchAirTicketCategories]);

    // Fallback static categories
    const fallbackCategories = [
        { id: 1, name: "Cruises", image: "/assets/img/category/category_1_1.jpg" },
        { id: 2, name: "Hiking", image: "/assets/img/category/category_1_2.jpg" },
        { id: 3, name: "Airbirds", image: "/assets/img/category/category_1_3.jpg" },
        { id: 4, name: "Wildlife", image: "/assets/img/category/category_1_4.jpg" },
        { id: 5, name: "Walking", image: "/assets/img/category/category_1_5.jpg" },
    ];

    // Use API data if available, otherwise use fallback
    const displayCategories = categories && categories.length > 0 ? categories : fallbackCategories;

    return (
        <section
            className="category-area3 bg-smoke space"
            style={{ backgroundImage: "url(/assets/img/bg/line-pattern3.png)" }}
        >
            <div className="container th-container">
                <div className="title-area text-center">
                    <span className="sub-title">Wonderful Place For You</span>
                    <h2 className="sec-title">Tour Categories</h2>
                </div>
                <div className="slider-area">
                    <Swiper
                        modules={[ Pagination, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={1}
                        breakpoints={{
                            576: { slidesPerView: 1 },
                            768: { slidesPerView: 2 },
                            992: { slidesPerView: 3 },
                            1200: { slidesPerView: 3 },
                            1400: { slidesPerView: 5 },
                        }}
                        pagination={{ clickable: true }}
                        autoplay={{ delay: 3000 }}
                        className="th-slider has-shadow category-slider3"
                    >
                        {displayCategories.map((category, index) => (
                            <SwiperSlide key={category.id}>
                                <div className="category-card single2">
                                    <div className="box-img global-img">
                                        <img 
                                            src={
                                                getImageUrl(category.image_url) || 
                                                category.image || 
                                                fallbackCategories[index % fallbackCategories.length]?.image || 
                                                '/assets/img/category/category_1_1.jpg'
                                            } 
                                            alt={category.name} 
                                            onError={(e) => {
                                                const fallbackImage = fallbackCategories[index % fallbackCategories.length]?.image || '/assets/img/category/category_1_1.jpg';
                                                e.target.src = fallbackImage;
                                            }}
                                        />
                                    </div>
                                    <h3 className="box-title">
                                        <Link to={`/categories/${category.slug || category.name.toLowerCase().replace(/\s+/g, '-')}`}>
                                            {category.name}
                                        </Link>
                                    </h3>
                                    {category.price_range && (
                                        <p 
                                            className="category-price"
                                            style={{
                                                fontSize: '14px',
                                                color: '#666',
                                                margin: '8px 0',
                                                fontWeight: '500'
                                            }}
                                        >
                                            <span className="price-range">{category.price_range}</span>
                                        </p>
                                    )}
                                    <Link 
                                        className="line-btn" 
                                        to={`/categories/${category.slug || category.name.toLowerCase().replace(/\s+/g, '-')}`}
                                    >
                                        See more
                                    </Link>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}

export default CategoryThree;
